import { useState, useEffect } from 'react';
import { doc, onSnapshot, setDoc, collection, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import { AY_ADLARI, GUN_ADLARI, ayKey, gunKey, ayinGunleri, paraCevir } from '../utils/takvim';
import { 
  ChevronLeft, ChevronRight, X, MapPin, HardHat, 
  DollarSign, Download, Check, ChevronDown, ChevronUp, Star, Users 
} from 'lucide-react';
import { exportPuantajExcel } from '../utils/excelExport';

export default function Takvim() {
  const bugun = new Date();
  const [yil, setYil] = useState(bugun.getFullYear());
  const [ay, setAy] = useState(bugun.getMonth());
  const [ustalar, setUstalar] = useState([]);
  const [santiyeler, setSantiyeler] = useState([]);
  const [ekipler, setEkipler] = useState([]);
  const [calisma, setCalisma] = useState({});
  const [avanslar, setAvanslar] = useState({});
  const [seciliGun, setSeciliGun] = useState(null);
  const [avansModalUsta, setAvansModalUsta] = useState(null);
  const [avansInput, setAvansInput] = useState('');
  const [acikSantiye, setAcikSantiye] = useState(null);

  const ak = ayKey(yil, ay);
  const gunler = ayinGunleri(yil, ay);
  const bosluklar = (new Date(yil, ay, 1).getDay() || 7) - 1;

  // Veri Çekme
  useEffect(() => {
    onSnapshot(query(collection(db, 'ustalar'), orderBy('ad', 'asc')), s => setUstalar(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    onSnapshot(collection(db, 'ekipler'), s => setEkipler(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    
    // Şantiyeleri favori durumuna göre sırala (Favori true olanlar üstte)
    onSnapshot(collection(db, 'santiyeler'), s => {
      const data = s.docs.map(d => ({ id: d.id, ...d.data() }));
      const sorted = data.sort((a, b) => (b.favori === true ? 1 : 0) - (a.favori === true ? 1 : 0));
      setSantiyeler(sorted);
    });

    onSnapshot(doc(db, 'aylikCalisma', ak), s => setCalisma(s.exists() ? s.data().kayitlar : {}));
    onSnapshot(doc(db, 'aylikAvans', ak), s => setAvanslar(s.exists() ? s.data() : {}));
  }, [ak]);

  const gununToplamAvansi = (t) => {
    const gk = gunKey(t);
    let toplam = 0;
    Object.values(avanslar).forEach(uMap => {
      if (typeof uMap === 'object' && uMap[gk]) toplam += Number(uMap[gk]);
    });
    return toplam;
  };

  const ayDegistir = (delta) => {
    let yeniAy = ay + delta;
    let yeniYil = yil;
    if (yeniAy > 11) { yeniAy = 0; yeniYil++; }
    if (yeniAy < 0) { yeniAy = 11; yeniYil--; }
    setAy(yeniAy); setYil(yeniYil);
  };

  const toggleCalisma = async (sId, uId) => {
    const gk = gunKey(seciliGun);
    const yeni = { ...calisma };
    if (!yeni[gk]) yeni[gk] = {};
    yeni[gk][uId] = yeni[gk][uId] === sId ? null : sId;
    if (!yeni[gk][uId]) delete yeni[gk][uId];
    await setDoc(doc(db, 'aylikCalisma', ak), { kayitlar: yeni });
  };

  const ekibiTopluAta = async (sId, ekipId) => {
    const gk = gunKey(seciliGun);
    const yeni = { ...calisma };
    if (!yeni[gk]) yeni[gk] = {};
    
    const ekipUstalari = ustalar.filter(u => u.ekipId === ekipId);
    const hepsiZatenBurada = ekipUstalari.every(u => yeni[gk][u.id] === sId);

    ekipUstalari.forEach(u => {
      if (hepsiZatenBurada) {
        delete yeni[gk][u.id]; // Zaten buradalarsa hepsini kaldır
      } else {
        yeni[gk][u.id] = sId; // Değillerse hepsini bu şantiyeye ata
      }
    });

    await setDoc(doc(db, 'aylikCalisma', ak), { kayitlar: yeni });
  };

  const saveAvans = async () => {
    const gk = gunKey(seciliGun);
    const yeni = { ...avanslar };
    if (typeof yeni[avansModalUsta.id] !== 'object') yeni[avansModalUsta.id] = {};
    yeni[avansModalUsta.id][gk] = Number(avansInput) || 0;
    await setDoc(doc(db, 'aylikAvans', ak), yeni);
    setAvansModalUsta(null);
  };

  return (
    <div className="p-4 sm:p-8 max-w-5xl mx-auto pb-24 space-y-6">
      {/* BAŞLIK VE NAVİGASYON (Görseldeki gibi korundu) */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-black text-white">Takvim</h1>
          <p className="text-[10px] text-stone-500 font-bold uppercase tracking-[0.2em]">Puantaj Düzenleme</p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <button onClick={() => exportPuantajExcel(yil, ay, ustalar, santiyeler, calisma, avanslar)} className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-2xl text-xs font-bold transition-all shadow-lg active:scale-95">
            <Download size={16} /> <span className="hidden sm:inline">EXCEL ÇIKTISI AL</span>
          </button>
          <div className="flex bg-stone-900 rounded-2xl p-1.5 border border-stone-800">
            <button onClick={() => ayDegistir(-1)} className="p-2 text-stone-400"><ChevronLeft size={20} /></button>
            <span className="text-xs font-black text-white px-4 min-w-[100px] text-center uppercase tracking-widest self-center">{AY_ADLARI[ay]} {yil}</span>
            <button onClick={() => ayDegistir(1)} className="p-2 text-stone-400"><ChevronRight size={20} /></button>
          </div>
        </div>
      </div>

      {/* TAKVİM IZGARASI (Görseldeki gibi korundu) */}
      <div className="bg-stone-900 border border-stone-800 rounded-[2.5rem] overflow-hidden shadow-2xl">
        <div className="grid grid-cols-7 bg-stone-800/30 border-b border-stone-800">
          {GUN_ADLARI.map(g => <div key={g} className="py-4 text-[9px] font-black text-stone-600 text-center uppercase tracking-widest">{g}</div>)}
        </div>
        <div className="grid grid-cols-7">
          {Array.from({ length: bosluklar }).map((_, i) => <div key={i} className="aspect-square border-b border-r border-stone-800/20" />)}
          {gunler.map(t => {
            const gk = gunKey(t);
            const uCount = Object.keys(calisma[gk] || {}).length;
            const gAvans = gununToplamAvansi(t);
            const isBugun = gk === gunKey(bugun);

            return (
              <button key={gk} onClick={() => { setSeciliGun(t); setAcikSantiye(null); }} className={`aspect-square border-b border-r border-stone-800/20 flex flex-col items-center justify-between py-2 sm:py-4 transition-all hover:bg-stone-800/40 relative ${isBugun ? 'bg-blue-500/5' : ''}`}>
                <span className={`text-xs font-black ${isBugun ? 'text-blue-400 underline underline-offset-4' : 'text-stone-500'}`}>{t.getDate()}</span>
                <div className="flex flex-col items-center gap-1">
                  {gAvans > 0 && <span className="text-[8px] font-black text-yellow-500">₺{gAvans}</span>}
                  <div className="flex gap-0.5">
                    {Array.from({ length: Math.min(uCount, 3) }).map((_, i) => <div key={i} className="w-1 h-1 rounded-full bg-green-500" />)}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* GÜNCEL VERİ GİRİŞ MODALI */}
      {seciliGun && (
        <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4 bg-black/95 backdrop-blur-md">
          <div className="bg-stone-900 w-full max-w-xl rounded-t-[2.5rem] sm:rounded-[2.5rem] max-h-[92vh] overflow-hidden flex flex-col border border-stone-800 shadow-2xl">
            <div className="p-6 border-b border-stone-800 flex justify-between items-center bg-stone-900">
              <div>
                <h3 className="text-xl font-black text-white">{seciliGun.getDate()} {AY_ADLARI[seciliGun.getMonth()]}</h3>
                <p className="text-[10px] text-stone-500 font-black uppercase tracking-[0.2em]">Puantaj & Ekip Dağılımı</p>
              </div>
              <button onClick={() => setSeciliGun(null)} className="p-3 bg-stone-800 rounded-2xl text-stone-400 hover:text-white"><X size={20} /></button>
            </div>

            <div className="flex-1 overflow-y-auto p-4 space-y-3 pb-24">
              <div className="flex items-center gap-2 text-stone-500 font-black text-[10px] uppercase tracking-widest px-2 mb-2"><MapPin size={14} /> Şantiyeler (Favoriler Üstte)</div>

              {santiyeler.filter(s => s.aktif !== false).map(s => {
                const isAcik = acikSantiye === s.id;
                const gk = gunKey(seciliGun);
                const calisanlar = Object.entries(calisma[gk] || {}).filter(([_, sId]) => sId === s.id);

                return (
                  <div key={s.id} className={`rounded-3xl border transition-all ${isAcik ? 'bg-stone-800/40 border-stone-700' : 'bg-stone-900 border-stone-800'}`}>
                    <button onClick={() => setAcikSantiye(isAcik ? null : s.id)} className="w-full flex items-center justify-between p-4">
                      <div className="flex items-center gap-3">
                        {s.favori ? <Star size={14} className="text-yellow-500 fill-yellow-500" /> : <MapPin size={14} className="text-stone-600" />}
                        <span className={`text-sm font-bold ${isAcik ? 'text-white' : 'text-stone-400'}`}>{s.ad}</span>
                      </div>
                      <div className="flex items-center gap-3">
                         <span className="text-[10px] font-black bg-stone-800 px-2 py-0.5 rounded-full text-stone-500">{calisanlar.length} KİŞİ</span>
                        {isAcik ? <ChevronUp size={18} className="text-stone-500" /> : <ChevronDown size={18} className="text-stone-600" />}
                      </div>
                    </button>

                    {isAcik && (
                      <div className="px-4 pb-4 space-y-6 animate-in slide-in-from-top-2 duration-200">
                        {/* EKİPLERE GÖRE LİSTELEME */}
                        {[...ekipler, {id: null, ad: 'Ekipsiz Ustalar'}].map(ekip => {
                          const ekipUstalari = ustalar.filter(u => u.ekipId === (ekip.id || undefined));
                          if (ekipUstalari.length === 0) return null;

                          return (
                            <div key={ekip.id || 'ekipsiz'} className="space-y-2">
                              <div className="flex items-center justify-between px-1">
                                <div className="text-[10px] font-black text-stone-600 uppercase tracking-widest flex items-center gap-1.5">
                                  <Users size={12}/> {ekip.ad}
                                </div>
                                {ekip.id && (
                                  <button onClick={() => ekibiTopluAta(s.id, ekip.id)} className="text-[9px] font-black text-blue-400 hover:text-blue-300">TÜM EKİBİ ATA / KALDIR</button>
                                )}
                              </div>
                              <div className="grid grid-cols-2 gap-2">
                                {ekipUstalari.map(u => {
                                  const aktif = calisma[gk]?.[u.id] === s.id;
                                  return (
                                    <button key={u.id} onClick={() => toggleCalisma(s.id, u.id)} className={`flex items-center justify-between p-3 rounded-2xl border text-[10px] font-black transition-all ${aktif ? 'bg-white border-white text-black' : 'bg-stone-800/50 border-stone-700 text-stone-500'}`}>
                                      <span className="truncate">{u.ad}</span>
                                      {aktif && <Check size={14} className="flex-shrink-0" />}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
              
              {/* AVANS BÖLÜMÜ (Mevcut yapı korundu) */}
              <div className="mt-8 pt-6 border-t border-stone-800 space-y-4">
                <div className="flex items-center gap-2 text-yellow-500 font-black text-[10px] uppercase tracking-widest px-2"><DollarSign size={14} /> Günlük Avanslar</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-1">
                  {ustalar.map(u => {
                    const av = avanslar[u.id]?.[gunKey(seciliGun)] || 0;
                    return (
                      <button key={u.id} onClick={() => { setAvansModalUsta(u); setAvansInput(av || ''); }} className="flex justify-between items-center p-4 bg-stone-800/30 rounded-2xl border border-stone-800">
                        <span className="text-xs font-bold text-stone-400">{u.ad}</span>
                        <span className={`text-sm font-black ${av > 0 ? 'text-yellow-500' : 'text-stone-800'}`}>{av > 0 ? paraCevir(av) : '0 ₺'}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* AVANS GİRİŞ MODAL (Mevcut yapı korundu) */}
      {avansModalUsta && (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-6 bg-black/95 backdrop-blur-sm">
          <div className="bg-stone-900 border border-stone-800 p-8 rounded-[2.5rem] w-full max-w-xs space-y-6">
            <div className="text-center">
              <h4 className="text-sm font-black text-white">{avansModalUsta.ad}</h4>
              <p className="text-[10px] text-stone-500 font-bold uppercase mt-1">Avans Miktarı</p>
            </div>
            <input type="number" value={avansInput} onChange={e => setAvansInput(e.target.value)} className="w-full bg-stone-800 border-2 border-stone-700 rounded-2xl p-4 text-white text-center text-2xl font-black outline-none focus:border-yellow-500" placeholder="0" autoFocus />
            <div className="grid grid-cols-2 gap-3">
              <button onClick={() => setAvansModalUsta(null)} className="py-4 rounded-2xl bg-stone-800 text-stone-400 font-bold text-xs">İPTAL</button>
              <button onClick={saveAvans} className="py-4 rounded-2xl bg-yellow-500 text-black font-black text-xs">KAYDET</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}